import React, { useState, useEffect } from 'react';
import AliceCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/alice-carousel.css';
import './Testimonials.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import maleCEO from '../../images/male-ceo.jpg';
import femaleCEO from '../../images/female-ceo.jpg';
import Tag from '../../components/Tag/Tag'



const Testimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);



  // Testimonials data array
  const testimonialsData = [
    {
      id: 1,
      name: "Lunozart Interiors",
      position: "Lunozart Interiors",
      image: maleCEO,
      rating: 5,
      quote: "Since partnering with Oma Media Space Limited, our page has experienced an amazing transformation. The content is always stunning and engaging, and our client base has grown significantly. They understand aesthetics—and that matters to us"
    },
    {
      id: 2,
      name: "GND Logistics",
      position: "GND Logistics",
      image: femaleCEO,
      rating: 5,
      quote: "We needed visibility and a solid digital push—Oma Media Space Limited delivered exactly that. Their strategic ad placements and creative management have helped us stand out in Lagos' logistics space. Highly recommended!."
    },
    {
      id: 3,
      name: "Sapphire Brows & Lashes",
      position: "Sapphire Brows & Lashes",
      image: maleCEO,
      rating: 5,
      quote: "Oma Media Space Limited made marketing effortless for us. From content creation to page growth, they knew just what our beauty brand needed. It's like having a creative team that truly gets you"
    },
    {
      id: 4,
      name: "CyberCohorts team",
      position: "CyberCohorts",
      image: femaleCEO,
      rating: 5,
      quote: "Working with Oma Media Space Limited has taken our online tech education community to the next level. Their content and ad strategies are top-notch, and we're reaching more tech-minded youths than ever."
    },
    {
      id: 5,
      name: "Michael Okorodudu",
      position: "CEO, Blak Communications",
      image: femaleCEO,
      rating: 5,
      quote: "We've trusted Oma Media Space Limited with multiple brands under us, and the results have been impressive. Whether it's travel, food, or fashion—they tailor each strategy perfectly. Professionalism at its peak."
    },
  ];



  const testimonial_elements = testimonialsData.map((testimonial) => {
    return (
      <div className="testimonials__card" key={testimonial.id}>
 
        <div className="testimonials__rating">
          {[...Array(testimonial.rating)].map((_, i) => (
            <span key={i} className="testimonials__star">★</span>
          ))}
        </div>
        <p className="testimonials__quote">"{testimonial.quote}"</p>
        <div className="testimonials__author">
          <p className="testimonials__name">{testimonial.name}</p>
          <p className="testimonials__position">{testimonial.position}</p>
        </div>
      </div>
    )
  });


  const responsive = {
    0:{
      items: 1
    },
    512:{
      items: 1
    },
    600:{
      items: 2
    },
    800:{
      items: 3
    },
  }




  return (
    <section className="testimonials">
      <div className="testimonials__container">
        <div className="testimonials__header">
          <Tag 
            title="Testimonials"
            variant="primary"
          />

          <h2 className="testimonials__title" data-aos="fade-up" data-aos-delay="100">
            What Our Client Says
          </h2>
          <p className="testimonials__subtitle" data-aos="fade-up" data-aos-delay="200">
            Listen to our clients' stories and see how we've helped them achieve success and growth
          </p>
        </div>


        <div className="testimonials__carousel" data-aos="fade-up" data-aos-delay="300">
          <div className="testimonials__slider" style={{ transform: `translateX(-${currentIndex * 50}%)` }}>
            <AliceCarousel 
              mouseTracking
              touchTracking
              autoPlayInterval={2000}
              animationDuration={4500}
              items={testimonial_elements}
              responsive = {responsive}
              autoPlay 
              infinite
              disableButtonsControls
              style={{paddingTop: '2%'}}
              autoHeight
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;



















// // Testimonials.jsx
// import React, { useState, useEffect } from 'react';
// import './Testimonials.css';
// import AOS from 'aos';
// import 'aos/dist/aos.css';
// import maleCEO from '../../images/male-ceo.jpg';
// import femaleCEO from '../../images/female-ceo.jpg';



// const Testimonials = () => {
//   const [currentIndex, setCurrentIndex] = useState(0);
  
//   useEffect(() => {
//     AOS.init({
//       duration: 1000,
//       once: true,
//     });
//   }, []);



//   // Testimonials data array
//   const testimonialsData = [
//     {
//       id: 1,
//       name: "John Smith",
//       position: "CEO, TechCorp",
//       image: maleCEO,
//       rating: 5,
//       quote: "Working with Diggrow has been amazing. They understood our goals and delivered a strategy that worked. Our online presence has grown significantly since we started."
//     },
//     {
//       id: 2,
//       name: "Emily Davis",
//       position: "CMO, FitLife",
//       image: femaleCEO,
//       rating: 5,
//       quote: "Diggrow played a key role in elevating our brand. Their strategic, efficient approach has greatly improved our online presence, leading to a 45% increase in leads."
//     },
//     {
//       id: 3,
//       name: "Michael Johnson",
//       position: "Founder, GreenTech",
//       image: maleCEO,
//       rating: 5,
//       quote: "I was impressed by Diggrow's attention to detail and their data-driven approach. They helped us optimize our website and increase conversion rates by 32%."
//     },
//     {
//       id: 4,
//       name: "Sarah Williams",
//       position: "Director, Nova Solutions",
//       image: femaleCEO,
//       rating: 5,
//       quote: "Choosing Diggrow was one of the best business decisions we've made. Their team is responsive, creative, and delivered results beyond our expectations."
//     },
// \
//   ];

//   const handlePrev = () => {
//     setCurrentIndex((prevIndex) => 
//       prevIndex === 0 ? testimonialsData.length - 2 : prevIndex - 1
//     );
//   };

//   const handleNext = () => {
//     setCurrentIndex((prevIndex) => 
//       prevIndex === testimonialsData.length - 2 ? 0 : prevIndex + 1
//     );
//   };



//   return (
//     <section className="testimonials">
//       <div className="testimonials__container">
//         <div className="testimonials__header">
//           <div className="testimonials__badge" data-aos="fade-up">
//             Testimonials <span className="testimonials__badge-icon">↗</span>
//           </div>
//           <h2 className="testimonials__title" data-aos="fade-up" data-aos-delay="100">
//             What Our Client Says
//           </h2>
//           <p className="testimonials__subtitle" data-aos="fade-up" data-aos-delay="200">
//             Listen to our clients' stories and see how we've helped them achieve success and growth
//           </p>
//         </div>

//         <div className="testimonials__carousel" data-aos="fade-up" data-aos-delay="300">
//           <div className="testimonials__slider" style={{ transform: `translateX(-${currentIndex * 50}%)` }}>
//             {testimonialsData.map((testimonial) => (
//               <div className="testimonials__card" key={testimonial.id}>
//                 <div className="testimonials__image-container">
//                   <img 
//                     src={testimonial.image} 
//                     alt={testimonial.name} 
//                     className="testimonials__image" 
//                   />
//                 </div>
//                 <div className="testimonials__rating">
//                   {[...Array(testimonial.rating)].map((_, i) => (
//                     <span key={i} className="testimonials__star">★</span>
//                   ))}
//                 </div>
//                 <p className="testimonials__quote">"{testimonial.quote}"</p>
//                 <div className="testimonials__author">
//                   <p className="testimonials__name">{testimonial.name}</p>
//                   <p className="testimonials__position">{testimonial.position}</p>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>

//         <div className="testimonials__controls" data-aos="fade-up" data-aos-delay="400">
//           <button className="testimonials__control testimonials__control--prev" onClick={handlePrev}>
//             <span className="testimonials__arrow">←</span>
//           </button>
//           <button className="testimonials__control testimonials__control--next" onClick={handleNext}>
//             <span className="testimonials__arrow">→</span>
//           </button>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Testimonials;